export async function DelayTimer(ms){
  return new Promise(resolve => setTimeout(resolve, ms));
 }